import { FETCH_BENCHMARK_CALCULATION_PARAMETER_RESPONSE, FETCH_CALCULATE_BENCHMARK_RESPONSE } from './action';

const automatedBenchmarkReducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_BENCHMARK_CALCULATION_PARAMETER_RESPONSE:
            return {
                ...state,
                benchmarkCalculationParams: action.data.data
            }
        case FETCH_CALCULATE_BENCHMARK_RESPONSE:
            return {
                ...state,
                benchmarkCalculationResponse: action.data.data
            }

        default:
            return state
    }
}

export default automatedBenchmarkReducer;